const MEMBERHUB_SERVICE_URL = import.meta.env.VITE_API_LEGACY_URL;
const BASE_URL = () => {
  switch (import.meta.env.VITE_API_ENV || 'staging') {
    case 'development':
      return import.meta.env.VITE_API_URL || 'https://api.givebacks.dev';
    case 'staging':
      return `https://api.givebacks.dev`;
    default:
      return `https://api.givebacks.com`;
  }
};

const SERVICES_URL = `${BASE_URL()}/services`;

const API_URLS = {
  BASE: BASE_URL(),
  BACKER: `${SERVICES_URL}/backer`,
  CORE: `${SERVICES_URL}/core`,
  COMMUNICATION: `${SERVICES_URL}/communication`,
  COMPLIANCE: `${SERVICES_URL}/compliance`,
  FEATURE: `${SERVICES_URL}/feature`,
  NOTIFICATION: `${SERVICES_URL}/notifications`,
  MEMBERHUB: `${MEMBERHUB_SERVICE_URL}/services/memberhub-service`,
  LEDGER: `${SERVICES_URL}/ledger`,
  OFFER: `${SERVICES_URL}/offer`,
  PAYOUT: `${SERVICES_URL}/payout`,
  STORE: `${SERVICES_URL}/store`,
  STUDENT: `${SERVICES_URL}/student`,
} as const;

export { API_URLS };
